import { Component, OnInit } from '@angular/core';
import { DashboardService } from '@features/dashboard/services/dashboard.service';

@Component({
  selector: 'app-loan-insight',
  templateUrl: './loan-insight.component.html',
})
export class LoanInsightComponent implements OnInit {

  insight$ = this.dashboardService.getLoanInsight();

  constructor(private dashboardService: DashboardService) { }

  ngOnInit(): void {
  }

}
